var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"preloader"},[_c('div',{staticClass:"preloader-wrap"},[_c('LottieAnimation',{attrs:{"path":"preloader.json","loop":true,"autoPlay":true,"speed":1,"width":150}}),_vm._m(0)],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"preloader__text"},[_c('p',{staticClass:"title"},[_vm._v("Loading...")]),_c('p',[_vm._v(" Wait a few seconds")])])
}]

export { render, staticRenderFns }